import { ia } from 'lib/helpers/utility';

import { amountToCents } from '../../Claims/CMS1500/lib/amountToCents';
import {
  denied_codes,
  patient_responsibility,
  provider_responsibility
} from '../../lib/insuranceAdjustmentGroups';

export const calcLatestBenefits = ({ procedure }) => {
  let ptAdj = 0;
  let insAdj = 0;

  const insTypes = ['tertiary', 'secondary', 'primary'];

  for (const insType of insTypes) {
    const adjustments = procedure?.[insType];

    if (ia(adjustments)) {
      const lastAdjustment = adjustments[adjustments?.length - 1];

      const processAdjustments = (adjustments) => {
        adjustments.forEach(({ group, code, amount, type = '' }) => {
          const hasPRCode = patient_responsibility[group]?.includes(+code) || type == 'pt_rep';
          const hasDeniedCode = denied_codes[group]?.includes(code);
          const isNotPR = provider_responsibility[group]?.includes(+code);
          const isPR45 = group === 'PR' && +code === 45;

          const isPatientRespFalse = lastAdjustment?.patient_responsibility === false;

          if (isPatientRespFalse && isPR45) return;
          if (type == 'ins_balance') return;

          if (!isNotPR && (group === 'PR' || hasPRCode || hasDeniedCode)) {
            ptAdj += amountToCents(amount);
          } else {
            insAdj += amountToCents(amount);
          }
        });
      };

      if (ia(lastAdjustment?.ins_adj)) processAdjustments(lastAdjustment.ins_adj);

      if (ia(lastAdjustment?.pt_adj)) processAdjustments(lastAdjustment.pt_adj);

      break;
    }
  }

  return { ptBalance: ptAdj, insAdj };
};
